"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPatternToRegexp = convertPatternToRegexp;
const _1 = require(".");
/**
 * Превращает паттерны типа glob в регулярки
 * Например `/path/to/** /something` превращает в `\/path\/to\/.*?\/something`
 * Пробел в примере надо, разумеется, убрать, он здесь, чтобы комментарий работал
 */
function convertPatternToRegexp(pattern) {
    return new RegExp('^' +
        (0, _1.escapeRegexpSpecialCharacters)(pattern)
            .replace(/\\?\*\\?\*/g, '.+?')
            .replace(/\\?\*/g, '[^\\/]+?') +
        '\\/?$');
}
//# sourceMappingURL=convert-pattern-to-regexp.util.js.map